import React, {Fragment, useContext} from 'react';
import themeContext from "../ThemeContext.js";
import {useTranslation} from "react-i18next";
import Divider from "@mui/material/Divider";
import {styled} from "@mui/material/styles";
import {ListItemButton} from "@mui/material";
import {DetailBarContext} from "../../middleware/DetailBarContext.js";
import {getBranchIcon} from "../../service/DashboardService.js";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import {Col, Row} from "react-bootstrap";
import {makeStyles} from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CurrencyFormat from "react-currency-format";

const Price = styled('span')(() => ({
    color: themeContext.color.main,
    lineHeight: '1',
    fontSize: '19px'
}));

const useStyles = makeStyles(() => ({
    cardTextMid: {
        color: `${themeContext.color.shadowBlack} !important`,
        textAlign: 'left !important',
        lineHeight: '1 !important',
        fontWeight: 'bold !important',
        fontSize: '14px !important',
        paddingBottom: '7px !important',
    },
    infoText: {
        fontSize: '12px !important',
        fontWeight: 'normal !important',
        color: `${themeContext.color.neutral400} !important`,
    },
}));

export const REFUND_TYPE = {
    ADD: 'add',
    MODIFY: 'modify',
    CONFIRM: 'confirm'
}

const RefundDetail = () => {
    const {t} = useTranslation();
    const {data, isLoading, updateData} = useContext(DetailBarContext);
    const classes = useStyles();

    const StyledListItemButton = styled(ListItemButton)(({main}) => ({
        width: `100%`,
        borderRadius: `12px`,
        padding: `4px 0 4px 8px`,
        height: `40px`,
        backgroundColor: main? themeContext.color.main : themeContext.color.main10,
        '&:hover': {
            backgroundColor:  main? themeContext.color.mainActive : themeContext.color.neutral100,
        }
    }));

    const StyledListItemText = styled(ListItemText)(({main}) => ({
        color: main ? themeContext.color.main : themeContext.color.white,
        textDecoration: `none`,
        textTransform: 'uppercase',
        textAlign: 'center'
    }));

    const formatText = (text) => {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    const publishEvent = (input) => {
        updateData({data: data.data, type: input});
    }

    const generateAndRetrieve = (title, index) => {
        return (
            <div key={index}>
                <Card key={title.id} style={{boxShadow: 'none'}}>
                    <CardContent style={{paddingBottom: '2px'}}>
                        <Row>
                            <Col
                                className="col-auto mr-0"
                                style={{'paddingRight': '0px'}}>
                                <img
                                    src={getBranchIcon(title.branch_name)}
                                    alt="type-policy-icon"/>
                            </Col>
                            <Col className="col-7">
                                <h6 className={classes.cardTextMid} style={title.branch_name.includes(' ') && title.branch_name.length > 20 ? {paddingTop: 0} : {paddingTop: '7px'}}>{formatText(title.branch_name)}</h6>
                            </Col>
                            <Col>
                                <Price className="mr-8">
                                    <CurrencyFormat
                                        displayType={'text'}
                                        value={title.premium.replace('-','')}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                    />€
                                </Price>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <h6 className={"card-text-content-2 ellipsis-1-v2"}>
                                    {t('dashboard.company-label')}
                                    <span className="font-weight-bold black">{title.company}</span>
                                </h6>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <h6 className={"card-text-content-2 ellipsis-1-v2"}>
                                    {t('dashboard.policy-number-label')}
                                    <span
                                        className="font-weight-bold black">{title.policynr}</span>
                                </h6>
                            </Col>
                        </Row>
                    </CardContent>
                </Card>
                <Divider className={'w-100'}/>
            </div>
        );
    };

    return (
        <Fragment>
            {isLoading ? <div className="background-loading-spinner spinner-desktop"></div> :
                <Fragment>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'center',
                        flexDirection: 'row',
                        width: '100%'
                    }}>
                        <span style={{fontWeight: 700, fontSize: '18px', color: themeContext.color.neutral600}}>
                            {t('desktop.refunds.detail.title')}
                        </span>
                    </div>
                    {data?.data &&
                        <Fragment>
                            {
                                <div className={'d-flex flex-column justify-content-between h-100 w-100'} style={{overflowY:'auto'}}>
                                    {
                                        data.data &&
                                        <List sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}>
                                            {
                                                data.data.titles.map((title, index) => (
                                                    generateAndRetrieve(title, index)
                                                ))
                                            }
                                        </List>
                                    }
                                </div>
                            }
                            { data.data?.stage === null &&
                                <div className={'d-flex flex-column-reverse h-auto w-100'}>
                                    <div className={'d-flex flex-column w-100'} style={{gap: 8}}>
                                        {data.data?.bank_ref?.iban ?
                                            <>
                                                <StyledListItemButton main={1}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        publishEvent(REFUND_TYPE.CONFIRM);
                                                    }}>
                                                    <StyledListItemText primary={t('desktop.refunds.detail.confirm')}/>
                                                </StyledListItemButton>
                                                <StyledListItemButton onClick={(event) => {
                                                        event.stopPropagation();
                                                        publishEvent(REFUND_TYPE.MODIFY);
                                                    }}>
                                                    <StyledListItemText main={1} primary={t('desktop.refunds.detail.modify')}/>
                                                </StyledListItemButton>
                                            </>
                                            :
                                            <StyledListItemButton main={1} onClick={(event) => {
                                                event.stopPropagation();
                                                publishEvent(REFUND_TYPE.ADD);
                                            }}>
                                                <StyledListItemText primary={t('desktop.refunds.detail.add')}/>
                                            </StyledListItemButton>
                                        }
                                    </div>
                                </div>
                            }
                        </Fragment>
                    }
                </Fragment>
            }
        </Fragment>
    );
};

export default RefundDetail;
